<template>
  <div>
    <slot v-bind:fields="fields" v-bind:fc="fieldClass"></slot>
  </div>
</template>

<script>
export default {
  name: "CompareFields",
  props: {
    ids: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      fields: this.ids.map(id => document.getElementById(id).value),
    };
  },
  computed: {
    fieldClass: function() {
      if (this.fields[this.fields.length - 1].length > 0) {
        if (this.fields.every( (val, i, arr) => val === arr[0] )) {
          return "controls-match";
        }
        return "controls-nomatch";
      }
      return null;
    },
  }
};
</script>

<style lang="scss">
@import "src/Template/assets/bootstrap_override";
@import "src/Template/assets/bootstrap_vars";

.controls-match {
  background-color: theme-color-level(success, -10);
}
.controls-nomatch {
  background-color: theme-color-level(danger, -10);
}
</style>